import React, { forwardRef } from 'react';
import { Chart } from '../../../../../../CommonComponents/OPL/charts/Chart';
import { RefObjectForHighchartsReact } from '../../../../../../CommonComponents/OPL/charts/Chart.types';
import { useDecumulationChart } from './useDecumulationChart';
import { ChartDataDTO } from '../../../../../api/useDecumulationGoalQuery';

interface Props {
  data: ChartDataDTO;
}

export const DecumulationChart = forwardRef<RefObjectForHighchartsReact, Props>((props, ref) => {
  const { chartConfig } = useDecumulationChart(props);

  return <Chart ref={ref} options={chartConfig} />;
});
